import { useEffect, useMemo } from "react";
import { useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  logout,
  selectBtcTv,
  selectGrp,
  selectRoleObj,
  selectUsername,
  setBtcTv,
  setGrp,
} from "../../features/auth/authSlice";
import { getBtcTv } from "../../services/btc/btcApi";
import { Button, Fade, IconButton, Menu, MenuItem, Stack, Typography } from "@mui/material";

import LogoutIcon from "@mui/icons-material/Logout";
import BtcMenu from "../Menu/BtcMenu";
import BtcTv from "./BtcMember";
import BtcUser from "./BtcUser";
import BtcUserDk from "./BtcUserDk";
import BtcAdmin, { BtcTitle, MyBtcLayout } from "./BtcAdmin";
import BtcQuy from "./BtcQuy";
import BtcHistory from "./BtcHistory";
import { DatePicker, LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ReportPage from "./BtcReport";
import BtcInit from "./BtcInit";
import { useLocation, useSearchParams } from "react-router-dom";
const Btc = ({ url, navigate, params = {} }) => {
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);

  // console.log(searchParams)
  const group = searchParams.get("group");

  const dispatch = useAppDispatch();
  const btcTv = useAppSelector(selectBtcTv);
  const email = useAppSelector(selectUsername);
  const grp = useAppSelector(selectGrp);
  const roleObj = useAppSelector(selectRoleObj);

  const [pending, setPending] = useState(true);

  useEffect(() => {
    async function fetchRole() {
      // {email, role: user|admin, tp: A|B|C}
      var { result: btcTv, error } = await getBtcTv(email, grp);
      if (btcTv) {
        dispatch(setBtcTv({ btcTv: btcTv }));
      } else {
        console.log(error);
      }

      setPending(false);
    }
    if (group && group !== grp) {
      dispatch(setGrp({ grp: group }));
      return;
    }
    fetchRole();
  }, [dispatch, email, grp, group]);
  // console.log(grp);
  if (pending) {
    return <>Loading...</>;
  }

  const sysAdmin = roleObj && roleObj.sys === "admin";

  if (url.match(/^\/BtcInit(\/|$)/i) && sysAdmin) {
    return <BtcInit navigate={navigate} params={params} />;
  }

  if (btcTv) {
    // is tv btc
    if (url.match(/^\/BtcUserDk(\/|$)/i)) {
      var id = url.slice("/BtcUserDk/".length);
      if (id.match(/^\w+$/)) {
        params.id = id;
      }
      return <BtcUserDk navigate={navigate} params={params} />;
    } else if (url.match(/^\/BtcUser$/i)) {
      return <BtcUser navigate={navigate} params={params} />;
    }

    if (url.match(/^\/BtcAdmin$/i) && btcTv.role === "admin") {
      return <BtcAdmin navigate={navigate} params={params} />;
    }
    if (url.match(/^\/BtcQuy$/i) && btcTv.role === "admin") {
      return <BtcQuy navigate={navigate} params={params} />;
    }
    if (url.match(/^\/BtcTv$/i) && btcTv.role === "admin") {
      return <BtcTv navigate={navigate} params={params} />;
    }
    if (url.match(/^\/BtcHistory$/i) && btcTv.role === "admin") {
      return <BtcHistory navigate={navigate} params={params} />;
    }
    if (url.match(/^\/BtcReport$/i) && btcTv.role === "admin") {
      return <ReportPage navigate={navigate} params={params} />;
    }
  }

  if (btcTv || sysAdmin) {
    return (
      <BtcMenu navi={navigate} />
    );
  } else {
    return (
      <div>
        <Typography
          color={"error"}
        >{`Địa chỉ gmail [${email}] chưa đăng ký với BTC-${grp.toUpperCase()}`}</Typography>
        <Button
          onClick={() => {
            dispatch(logout());
          }}
          endIcon={<LogoutIcon />}
        >
          {"Đăng xuất"}
        </Button>
      </div>
    );
  }
};
export default Btc;
export function BtcTimePicker({gio, onChange}) {
  return <Stack spacing={{xs:1,sm:2}} direction={"row"} sx={{alignItems:"center"}}>
    <Typography>{"Giờ"}</Typography>
    <LocalizationProvider dateAdapter={AdapterDayjs}>
  <TimePicker
    // sx={{ width: "130px" }}
    ampm={false}
    views={['hours', 'minutes', 'seconds']}
    value={dayjs("1900-01-01 " + (gio || "00:00:00"))}
    onChange={(newValue) => onChange(newValue.format("HH:mm:ss"))} />
</LocalizationProvider></Stack>;
}
export function EditMenu({ options, children }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <div>
      <Button
        id="fade-button"
        aria-controls={open ? "fade-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        {children}
      </Button>
      <Menu
        id="fade-menu"
        MenuListProps={{
          "aria-labelledby": "fade-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        TransitionComponent={Fade}
      >
      {options.map((opt, idx)=>( <MenuItem
      key={idx}
          onClick={() => {
            handleClose();
            opt.cb();
          }}
        >
          {opt.label}
        </MenuItem>))}
      </Menu>
    </div>
  );
}


export function DateTimeEdit({
  gio,        // "HH:mm:ss"
  ngay,       // "yyyy-MM-dd"
  onChange,   // ({ ngay, gio })
}) {
  // ✅ merge date + time → dayjs
  const value = useMemo(() => {
    if (!ngay || !gio) return null;
    return dayjs(`${ngay} ${gio}`, "YYYY-MM-DD HH:mm:ss");
  }, [ngay, gio]);

  const handleChange = (newValue) => {
    if (!newValue || !newValue.isValid()) return;

    onChange({
      ngay: newValue.format("YYYY-MM-DD"),
      gio: newValue.format("HH:mm:ss"),
    });
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Stack direction="row" spacing={1} alignItems="center">
        {/* DATE */}
        <DatePicker
          value={value}
          format="YYYY.MM.DD"
          onChange={handleChange}
          slotProps={{
            textField: {
              variant: "standard",
              size: "small",
              InputProps: { disableUnderline: true },
              sx: { width: 110 },
            },
          }}
        />

        {/* TIME */}
        <TimePicker
          value={value}
          ampm={false}
          format="HH:mm:ss"
          onChange={handleChange}
          slotProps={{
            textField: {
              variant: "standard",
              size: "small",
              InputProps: { disableUnderline: true },
              sx: { width: 90 },
            },
          }}
        />
      </Stack>
    </LocalizationProvider>
  );
}
